import { useQuery } from "@tanstack/react-query";
import { api } from "../config/api";

export const WALLET_BALANCE_KEY = ["wallet-balance"];

// Short Indian format for tight spaces: ₹950, ₹45.2K, ₹12.5L, ₹9.96Cr.
export const formatCompactINR = (n: number) => {
  const abs = Math.abs(n);
  const sign = n < 0 ? "-" : "";
  const short = (v: number, unit: string) => `${sign}₹${Number(v.toFixed(v >= 100 ? 0 : 2))}${unit}`;
  if (abs >= 1e7) return short(abs / 1e7, "Cr");
  if (abs >= 1e5) return short(abs / 1e5, "L");
  if (abs >= 1e4) return short(abs / 1e3, "K");
  return `${sign}₹${abs.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
};

export const formatFullINR = (n: number) => `₹${n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Wallet balance shown in the top bar and on the Billing page (one shared, cached request).
export const useWalletBalance = (enabled = true) =>
  useQuery({
    queryKey: WALLET_BALANCE_KEY,
    queryFn: async () => {
      const res = await api.get("/payment/amountInWallet/");
      const n = Number(res?.data?.data ?? 0);
      return Number.isFinite(n) ? n : 0;
    },
    enabled,
    staleTime: 30_000,
    retry: 1,
  });
